import script from "./IonicTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./IonicTable.vue?vue&type=script&setup=true&lang=ts"

import "./IonicTable.vue?vue&type=style&index=0&id=04c1128e&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04c1128e"]])

export default __exports__